import { FC } from 'react'

import { StarIcon } from 'assets/icons/star-icon'

interface RatingProps {
  rating: number
}

export const Rating: FC<RatingProps> = ({ rating }) => {
  return (
    <div className="flex items-center gap-2">
      <StarIcon />
      <span className="text-lg font-bold">{rating}</span>
    </div>
  )
}
